import React from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, NavbarBrand, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Footer from '@components/Footer';
import { Subscription } from 'rxjs';

class ForgottenPassword extends React.Component {
    constructor(props) {
        super(props);
        this.subscriptions = new Subscription();

        this.state = {
            email: '',
            validationError: ''
        }

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentWillUnmount() {
        this.subscriptions.unsubscribe();
    }

    onChange(e) {
        const trg = e.target;

        this.setState(prevState => {
            prevState.email = trg.value;
            prevState.validationError = '';
            return prevState;
        });
    }

    validate() {
        const re = /\S+@\S+\.\S+/;
        let isValid = re.test(this.state.email);

        if (!isValid) this.setState({ validationError: 'Please provide correct email address' });
        return isValid;
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.validate()) {
            axios({
                method: 'POST',
                url: window.location.origin + '/p/reset-password-request/',
                data: { email: this.state.email }
            })
                .then(resp => toast.success('Instructions to reset your password have been sent.  Please check your email. Click "Cancel" below to return to the login page.'))
                .catch(e => toast.error(e.response.data.message));
        }
    }

    render() {
        return (
            <div className="simple-page">
                <header className="app-header navbar">
                    <Container className="fluid">
                        <div className="fp-top">
                            <Row>
                                <Col><NavbarBrand href="https://www.corlytics.com"></NavbarBrand></Col>
                            </Row>
                        </div>
                    </Container>
                </header>
                <Container>
                    <Row>
                        <Col>
                            <div className="card">
                                <div className="card-header"><span style={{ fontSize: "1.5rem" }}>Forgot Password ?</span></div>
                                <div className="card-block">
                                    <Form onSubmit={this.onSubmit}   >
                                        <FormGroup>
                                            <div style={{ marginTop: "50px", marginBottom: "50px" }}>
                                                <Label htmlFor="email" >To reset your password, enter your email address.</Label>
                                                <Input name="email" type="text" value={this.state.email} maxLength="255" onChange={this.onChange} />
                                                {this.state.validationError.length > 0 &&
                                                    <div className="font-weight-bold" style={{ fontSize: '0.7rem', color: '#c00' }}>{this.state.validationError}</div>
                                                }
                                            </div>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col>
                                                <Link to="/login">
                                                    <button className="btn btn-secondary-new" size="lg">Cancel</button>
                                                </Link>
                                            </Col>
                                            <Col className="text-right">
                                                <button
                                                    type="submit"
                                                    size="lg"
                                                    className="float-right btn btn-primary-new"
                                                    disabled={!this.state.email.length}
                                                >Continue</button>
                                            </Col>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </div>
        )
    }
}

export default ForgottenPassword;



// WEBPACK FOOTER //
// ./src/views/Pages/ForgottenPassword/ForgottenPassword.js